import { TenantEntity } from '../TenantEntity'
import { DataSyncBase } from '@/class/model/DataSyncBase'

export class QuotationChargeDetail extends DataSyncBase {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'QuotationChargeDetail'
  }

  get serialNumber() {
    return this._data.serialNumber
  }
  set serialNumber(serialNumber) {
    this._data.serialNumber = serialNumber || 0
  }
  get chargeId() {
    return this._data.chargeId
  }
  set chargeId(chargeId) {
    this._data.chargeId = chargeId || 0
  }
  get chargeName() {
    return this._data.chargeName
  }
  set chargeName(chargeName) {
    this._data.chargeName = chargeName
  }
  get type() {
    return this._data.type
  }
  set type(type) {
    this._data.type = type || 0
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get rate() {
    return this._data.rate
  }
  set rate(rate) {
    this._data.rate = rate || 0
  }
  get costRate() {
    return this._data.costRate
  }
  set costRate(costRate) {
    this._data.costRate = costRate || 0
  }
  get unit() {
    return this._data.unit
  }
  set unit(unit) {
    this._data.unit = unit
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get num() {
    return this._data.num
  }
  set num(num) {
    this._data.num = num || 0
  }
  get amount() {
    return this._data.amount
  }
  set amount(amount) {
    this._data.amount = amount || 0
  }
  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid
  }
}
